/**
 * Consumer Portal admin pages a user may access. Carried on the auth `Role`
 * claim and used to decide which admin page/tab is shown. Values mirror the
 * admin entries of the Consumer Portal `ComponentsToLoad` enum.
 */
export enum AdminRole {
    AdminOverview = 'AdminOverview',
    AdminDifference = 'AdminDifference',
    AdminSetup = 'AdminSetup',
    AdminAccountList = 'AdminAccountList',
    AdminAnalytics = 'AdminAnalytics'
}
